<div class="welcome-card-dialog">
  <h2 mat-dialog-title>Generate Welcome Card</h2>

  <mat-dialog-content>
    <p>Generate the welcome card using your current filter criteria.</p>

    <div class="button-container">
      <button mat-raised-button
        color="primary"
        class="option-button"
        (click)="generateWithCurrentFilter()">
        <mat-icon>filter_list</mat-icon>
        Generate with Current Filter Criteria
      </button>
    </div>

    @if (data?.currentFilters) {
      <div class="current-filters">
        <h4>Current Filters</h4>
        <mat-list>
          @for (key of currentFilterKeys; track key) {
            <mat-list-item>
              <div mat-line>{{ key }}</div>
              <div mat-line class="secondary">
                {{ displayFilterValue(data.currentFilters[key]) }}
              </div>
            </mat-list-item>
          }
        </mat-list>
      </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancel</button>
  </mat-dialog-actions>
</div>

